import { configureStore } from '@reduxjs/toolkit';
import uiReducer from './uiSlice';
import pageLoaderReducer from './pageLoaderSlice';

export const store = configureStore({
    reducer: {
        ui: uiReducer,
        pageLoader: pageLoaderReducer,
    },
    middleware: (getDefault) => getDefault(),
    devTools: import.meta.env.MODE !== 'production',
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
